import React, { useState } from 'react';
import { Button } from "primereact/button";
import { IAvailableTime } from "../../interfaces"
import './styles.css';

export function AvailableTime(props: IAvailableTime) {
    // TODO create timestamp to label convert function
    const timeStampToLabel = (date: string) => {
        var d = new Date(date);
        var a = d.getHours().toString().padStart(2, '0') + ":" + d.getMinutes().toString().padStart(2, '0')
        return a;
    }

    const handleTimeSelect = () => {
        props.onTimeSelect(props.index);
    }
    
    if (!props.selected) {
        return <Button label={timeStampToLabel(props.timeStamp)} className='available-time p-button-outlined' style={{height: '30px'}} onClick={() => handleTimeSelect()}/>
    } else {
        return <div className='p-d-flex'> 
            {/* TODO divo class turi buti between */}
            {/* TODO buttonu klases turi buti kitokios */}
            <Button label={timeStampToLabel(props.timeStamp)} className='available-time p-button-secondary' disabled style={{width: '47%', float: 'left'}}/>
            <Button label={T("action.confirm")} onClick={() => props.onTimeConfirm(props.timeStamp)} className='available-time' style={{width: '47%', float: 'right'}} />
        </div>
    }
}